module.exports = "/_next/static/images/DeliveryDestinations-1058150b071e29ce7ec27990ed949add.webp";